export default class Cropper {
  constructor (image) {
    import('cropperjs/dist/cropper.min.css');      
    return new Promise((resolve, reject) => {
      return import('cropperjs').then(({ default: cropperJs }) => {
        this.cropper = new cropperJs(image, {
          aspectRatio: 1,
          viewMode: 1,
          guides: false
        });
        resolve(this.cropper);
      }).catch(reject);
    });
  }

  destroy() {
    this.cropper.destroy();
    this.cropper = null;
  }
}
